import { render, staticRenderFns } from "./WorkerList.vue?vue&type=template&id=1af886ce&scoped=true"
import script from "./WorkerList.vue?vue&type=script&lang=js"
export * from "./WorkerList.vue?vue&type=script&lang=js"
import style0 from "./WorkerList.vue?vue&type=style&index=0&id=1af886ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af886ce",
  null
  
)

export default component.exports